
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external-transmission-rule",
      function () {
        return require("private-next-pages/external-transmission-rule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external-transmission-rule"])
      });
    }
  